export interface CtaButtonItem {
  label: string;
  icon: string;
  callback: () => void;
}
